import React from 'react'
import VideoModal from '../../components/ModalVideo'
import abimg from '../../images/about2.jpg'
import abimg2 from '../../images/about3.jpg'


const About2 = (props) => {
    return (
        <div className="wpo-about-area-s2 section-padding">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12 col-sm-12">
                        <div className="wpo-about-img">
                            <div className="wpo-about-img-left">
                                <img src={abimg} alt="" loading="lazy" decoding="async"/>
                                    <div className="wpo-about-img-text">
                                        <h2>70+</h2>
                                        <p>Years of Excellence</p>
                                    </div>
                            </div>
                            <div className="wpo-about-img-right">
                                <img src={abimg2} alt="" loading="lazy" decoding="async"/>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-md-12 colsm-12">
                        <div className="wpo-about-text">
                            <div className="wpo-about-title">
                                <span>About Giga Group</span>
                                <h2>Delivering Excellence Since 1956</h2>
                            </div>
                            <p>Giga Group of companies is a trusted business conglomerate in Pakistan with 7 decades of excellence. The group has a diversified portfolio of industries. Including real estate development, textiles, gold refining, and bullion trading, reflecting its broad and integrated vision of sustainable growth. Founded by Haji Abdul Karim Giga in 1956, what began as one bold step has evolved into an enterprise that continues to grow and expand. As an award-winning real estate developer in Pakistan, our vision is inspired by Dubai’s remarkable transformation under the visionary leadership of His Highness Sheikh Mohammed Rashid bin Rashid Al Makhtoum and His Highness Sheikh Mohamed bin Zayed Al Nayan. Their commitment to innovation, excellence, and world-class development has set global benchmarks in urban planning, governance, and quality of life. A standard we strive to bring to every project we build.</p>
                            <ul className="ab-list">
                                <li>Over 70 years of business excellence and premium quality development</li>
                                <li>5,000+ employees worldwide delivering world-class projects</li>
                                <li>18M+ sq ft of commercial & residential space, with 99.99% of customer satisfaction</li>
                                <li>Iconic projects like Goldcrest Views and Giga Mall, redefining living</li>
                            </ul>
                            <div className="btns">
                                <a href="#contact-form" className="theme-btn">Contact Us</a>
                                <ul>
                                    <li className="video-holder">
                                        <VideoModal />
                                    </li>
                                    <li className="video-text">
                                        Watch Our Video
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default About2;